import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    title: 'GoalMate | Stay focused on your goals',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
  },
];
